import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import userReducer from './user/userReducer'
import tokenReducer from './user/tokenReducer'
import cityReducer from './user/cityReducer'
import web3Reducer from './util/web3/web3Reducer'
import proposalReducer from './user/proposalReducer'
import transactionReducer from './user/transactionReducer'

const reducer = combineReducers({
    routing: routerReducer,
    user: userReducer,
    web3: web3Reducer,
    token: tokenReducer,
    city: cityReducer,
    proposal: proposalReducer,
    transaction: transactionReducer
})

export default reducer



// WEBPACK FOOTER //
// ./src/reducer.js